"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthPicker = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var function_1 = require("fp-ts/function");
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var React = __importStar(require("react"));
var string_1 = require("../../library/string");
var Popover_1 = require("../Popover");
var ContentPopover_1 = require("../Popover/ContentPopover");
var PickerActivator_1 = require("./PickerActivator");
require("./monthPicker.css");
var MonthPicker = /** @class */ (function (_super) {
    __extends(MonthPicker, _super);
    function MonthPicker(props) {
        var _this = _super.call(this, props) || this;
        var selectedDate = (0, function_1.pipe)(O.fromNullable(_this.props.value), O.map(function (date) { return date.clone().startOf('month'); }), O.getOrElse(function () { return (0, moment_timezone_1.default)().startOf('month'); }));
        _this.state = {
            viewDate: selectedDate,
            currentView: 'months',
            open: false,
        };
        return _this;
    }
    MonthPicker.prototype.changeView = function (view) {
        this.setState({ currentView: view });
    };
    MonthPicker.prototype.setViewDate = function (startDate) {
        this.setState({ viewDate: startDate });
    };
    MonthPicker.prototype.setViewDateAndView = function (startDate, view) {
        this.setState({ viewDate: startDate, currentView: view });
    };
    MonthPicker.prototype.selectedDate = function (startDate) {
        var _this = this;
        if (startDate.isSame(this.props.value)) {
            return;
        }
        this.setState({
            viewDate: startDate,
            open: false,
        }, function () { return _this.props.onChange && _this.props.onChange(startDate); });
    };
    MonthPicker.prototype.renderMonths = function () {
        var _this = this;
        var list = [];
        list.push((0, jsx_runtime_1.jsx)("div", __assign({ className: "col", onClick: this.setViewDate.bind(this, this.state.viewDate.clone().subtract(1, 'year')) }, { children: "<" }), "prev"));
        list.push((0, jsx_runtime_1.jsx)("div", __assign({ className: "col", onClick: this.changeView.bind(this, 'years') }, { children: this.state.viewDate.format('YYYY') }), "currentYear"));
        list.push((0, jsx_runtime_1.jsx)("div", __assign({ className: "col", onClick: this.setViewDate.bind(this, this.state.viewDate.clone().add(1, 'year')) }, { children: ">" }), "next"));
        var months = moment_timezone_1.default.monthsShort().map(function (monthName, index) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('col', {
                active: _this.getNumberFromSelectedDate('M') === index + 1 &&
                    parseInt(_this.state.viewDate.format('YYYY')) === _this.getNumberFromSelectedDate('YYYY'),
            }), onClick: _this.selectedDate.bind(_this, _this.state.viewDate.clone().startOf('year').add(index, 'month')) }, { children: (0, string_1.capitalizeFirstLetter)(monthName) }), index)); });
        list.push.apply(list, months);
        return list;
    };
    MonthPicker.prototype.renderYears = function () {
        var list = [];
        list.push((0, jsx_runtime_1.jsx)("div", __assign({ className: "col", onClick: this.setViewDate.bind(this, this.state.viewDate.clone().subtract(12, 'year')) }, { children: "<" }), "prev"));
        list.push((0, jsx_runtime_1.jsx)("div", __assign({ className: "col", onClick: this.changeView.bind(this, 'months') }, { children: this.state.viewDate.format('YYYY') }), "currentYear"));
        list.push((0, jsx_runtime_1.jsx)("div", __assign({ className: "col", onClick: this.setViewDate.bind(this, this.state.viewDate.clone().add(12, 'year')) }, { children: ">" }), "next"));
        var fromYear = parseInt(this.state.viewDate.clone().subtract(6, 'year').format('YYYY'));
        for (var currentYear = fromYear; currentYear < fromYear + 12; currentYear++) {
            list.push((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('col', { active: this.getNumberFromSelectedDate('YYYY') === currentYear }), onClick: this.setViewDateAndView.bind(this, this.state.viewDate
                    .clone()
                    .subtract(6, 'year')
                    .add(currentYear - fromYear, 'year'), 'months') }, { children: currentYear }), currentYear));
        }
        return list;
    };
    MonthPicker.prototype.renderList = function () {
        switch (this.state.currentView) {
            case 'months':
                return this.renderMonths();
            case 'years':
                return this.renderYears();
        }
    };
    MonthPicker.prototype.getNumberFromSelectedDate = function (format) {
        if (!this.props.value) {
            return undefined;
        }
        return parseInt(this.props.value.format(format));
    };
    MonthPicker.prototype.formatSelectedDateAsActivatorLabel = function () {
        if (!this.props.value) {
            return undefined;
        }
        var selectedDate = this.props.value.format('MMMM YYYY');
        return (0, string_1.capitalizeFirstLetter)(selectedDate);
    };
    MonthPicker.prototype.renderResetPicker = function () {
        var _this = this;
        if (!this.props.resettable) {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('cancel-selection', { active: !this.props.value }), onClick: function () {
                return _this.setState({ open: false }, function () { return _this.props.onChange && _this.props.onChange(undefined); });
            } }, { children: this.props.resetLabel })));
    };
    MonthPicker.prototype.render = function () {
        var _this = this;
        var onClickActivator = function () { return _this.setState({ open: !_this.state.open }); };
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "month-picker" }, { children: (0, jsx_runtime_1.jsxs)(Popover_1.Popover, __assign({ open: this.state.open, onClickOutside: onClickActivator, appendClickListenerToElementRef: this.props.appendClickListenerToElementRef }, { children: [(0, jsx_runtime_1.jsx)(PickerActivator_1.PickerActivator, { label: this.props.label, icon: this.props.icon, labelPicked: this.formatSelectedDateAsActivatorLabel() || '-', onClick: onClickActivator, disabled: this.props.disabled, theme: this.props.pickerTheme, type: this.props.pickerType }), (0, jsx_runtime_1.jsxs)(ContentPopover_1.ContentPopover, __assign({ theme: this.props.contentTheme }, { children: [this.renderResetPicker(), (0, jsx_runtime_1.jsx)("div", __assign({ className: "calendar" }, { children: this.renderList() }))] }))] })) })));
    };
    MonthPicker.defaultProps = {
        label: 'Dati relativi a',
        disabled: false,
        contentTheme: 'default',
        pickerType: 'default',
        pickerTheme: 'primary',
        icon: 'icon_calendar_light',
        resettable: false,
        resetLabel: 'Nessuna di queste',
        eventHandler: document,
    };
    return MonthPicker;
}(React.Component));
exports.MonthPicker = MonthPicker;
//# sourceMappingURL=MonthPicker.js.map